import __ from '../../locales/__';
export default class Rule {
    // @ts-ignore
    value;
    customAttribute;
    constructor({ value = '', customAttribute }) {
        this.value = value;
        /* Used to replace the :attribute in message */
        this.customAttribute = customAttribute;
    }
    get ruleName() {
        return 'rule';
    }
    tradMessage(valueType = '') {
        return __('messages.' + this.ruleName + (valueType !== '' ? '.' + valueType : ''));
    }
    tradAttribute(attribute) {
        return __('attributes.' + attribute);
    }
    message(valueType) {
        return this.replaceMessage(this.tradMessage(valueType), 'attribute', this.tradAttribute(this.customAttribute));
    }
    replaceMessage(message, attribute, value) {
        return message.replace(':' + attribute, value);
    }
}
